import React, { useState } from 'react';
import { cx } from '@twind/core';
import { ChatItemVideo } from 'app/services/chatBot';
import VideoPlayer from 'app/components/VideoPlayer';

import useVirtualAssistantAvatar from '../../hooks/useVirtualAssistantAvatar';
import BaseChatItem from './BaseChatItem';

export default function VideoChatItem({
  chatItem,
  hideAvatar,
  className,
}: {
  chatItem: ChatItemVideo;
  hideAvatar?: boolean;
  className?: string;
}) {
  const avatarURL = useVirtualAssistantAvatar();
  const [playing, setPlaying] = useState(false);

  const { url, placeholder_image_url, video_name, title } = chatItem;

  const videoTitle = title || video_name || 'Video content';
  const videoDescription = `${videoTitle}${video_name && title && video_name !== title ? ` - ${video_name}` : ''}`;

  return (
    <BaseChatItem
      avatarURL={avatarURL}
      className={cx('ostro-chat-item-video', className)}
      showAvatar={!hideAvatar}
      isUserMessage={false}
    >
      <div className="max-w-full">
        <div
          aria-label="Video player"
          aria-describedby={`video-desc-${chatItem.url ? chatItem.url.split('/').pop() : 'unknown'}`}
        >
          <span
            id={`video-desc-${chatItem.url ? chatItem.url.split('/').pop() : 'unknown'}`}
            className="sr-only"
          >
            {`Video player containing: ${videoDescription}. Use video controls to play, pause, and adjust settings.`}
          </span>
          <VideoPlayer
            title={title}
            url={url}
            video_name={video_name}
            controls
            muted
            width="100%"
            height="180px"
            className="mb-4 overflow-hidden"
            light={placeholder_image_url}
            playing={playing}
            onClickPreview={(e) => {
              e.stopPropagation();
              setPlaying(true);
            }}
          />
        </div>
      </div>
    </BaseChatItem>
  );
}
